import React from 'react'
import { Wrapper } from './style'
import { NoPlanSvg } from 'src/assets'

const NoPlan = ({ children }: any) => {
  return (
    <Wrapper>
      <div className="no_plan_item">
        <img src={NoPlanSvg} alt="" />
        <p>{children}</p>
      </div>
    </Wrapper>
  )
}

export default NoPlan
